import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  /**
   * Used to handle the notification count
   */
  notificationUpdated = new Subject();

  constructor() { }
}
